import { Directive, ElementRef, HostListener, inject } from '@angular/core';

@Directive({ selector: '[appHighlight]' })
export class HighlightDirective {
  private el = inject(ElementRef);

  @HostListener('focus')
  public onFocus(): void {
    this.highlight('focus-within');
  }

  @HostListener('focusout')
  public onFocusout(): void {
    this.highlight(null);
  }

  private highlight(className: string): void {
    if (className !== null) {
      this.el.nativeElement.parentElement.parentElement.classList.add(className);
    } else {
      this.el.nativeElement.parentElement.parentElement.classList.remove('focus-within');
    }
  }
}
